import businessesTypes from '../../constants/businessesTypes'
import auth_types from '../../constants/authTypes'
export * from './create'
export * from './get'
export * from './getindex'
export * from './activate'
export * from './update'

const set_business_errors = (messages) => {
  return {
    type: businessesTypes.set_errors,
    payload: messages
  }
}

const reset_business = () => {
  return {
    type: businessesTypes.reset_business
  }
}

const clear_business = () => {
  return {
    type: businessesTypes.clear_business
  }
}

const update_current_business = (response) => {
  return {
    type: auth_types.set_current_business,
    payload: response.data.business
  }
}

export {
  set_business_errors,
  reset_business,
  clear_business,
  update_current_business
}



// WEBPACK FOOTER //
// ./src/js/actions/businesses/index.js